module.exports = __webpack_public_path__ + "static/DeceitThumb-5726ccc415452364f4f1febddb4b4efd.jpg";